var _path, _path2, _rect, _line, _line2, _path3, _line3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitacoraEnvasado(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#CD973D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 8,
    height: 4,
    rx: 1,
    ry: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9,
    x2: 17,
    y2: 9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 13,
    x2: 13,
    y2: 13
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14 L18.5 14 L18.5 16.5 L20 18 L20 22.5 L16 22.5 L16 18 L17.5 16.5 Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 20,
    x2: 19.5,
    y2: 20
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitacoraEnvasado);
export default __webpack_public_path__ + "static/media/bitacoraEnvasado.c7c55c51f78a6e91b886804232e38d0d.svg";
export { ForwardRef as ReactComponent };